import { Field, Loading, PageHead, Panel, SaveBtn, inputCls, useSiteDraft } from "@/admin/ui";

const FIELDS = [
  ["india_rate", "India delivery rate (₹)"], ["india_free", "India free delivery over (₹)"],
  ["intl_rate", "International delivery rate (₹)"], ["intl_free", "International free delivery over (₹)"],
];

export default function Shipping() {
  const { draft, patch, save, saving } = useSiteDraft(["shipping", "delivery"]);
  if (!draft) return <Loading />;
  const s = draft.shipping;
  const d = draft.delivery;
  return (
    <div className="max-w-2xl">
      <PageHead title="Shipping" desc="Flat delivery rate per order. Set a free-delivery threshold to 0 to never offer free delivery.">
        <SaveBtn save={save} saving={saving} />
      </PageHead>
      <Panel className="grid sm:grid-cols-2 gap-5">
        {FIELDS.map(([k, label]) => (
          <Field key={k} label={label}>
            <input type="number" min="0" value={s[k]} onChange={(e) => patch("shipping", { ...s, [k]: e.target.value })} className={inputCls} data-testid={`shipping-${k}`} />
          </Field>
        ))}
      </Panel>
      <Panel className="grid gap-5 mt-6">
        <p className="font-bold text-sm">Delivery time shown on product pages</p>
        <Field label="Default text (all products)">
          <input value={d.default_text} onChange={(e) => patch("delivery", { ...d, default_text: e.target.value })} className={inputCls} data-testid="delivery-default-text" />
        </Field>
        <Field label="Express text (products you mark for express delivery)">
          <input value={d.express_text} onChange={(e) => patch("delivery", { ...d, express_text: e.target.value })} className={inputCls} data-testid="delivery-express-text" />
        </Field>
        <p className="text-xs text-zinc-500">Mark products for express delivery in Products: tick them and click "Express delivery", or switch it on inside a product.</p>
      </Panel>
    </div>
  );
}
